import { useMutation } from "react-query";
import { updateTEMPVehicle } from "store/api/api";
import { handleAxiosError } from "store/util";
import { Vehicle } from "types/types";
import { MUTATION_KEYS } from "../queryKeys";

const updateTempVehicleFn = async (params: Vehicle) => {
  return await updateTEMPVehicle(params);
};

export function useUpdateTempVehicle() {
  return useMutation(updateTempVehicleFn, {
    mutationKey: MUTATION_KEYS.updateTempVehicle,

    onError: (err) => {
      handleAxiosError(err);
    },
  });
}
